const alreadyExecuted = new Set<string>();

/**
 * Executes the provided string as Javascript in the global scope.
 */
export async function loadGlobalScript(code: string): Promise<void> {
    if (alreadyExecuted.has(code)) return Promise.resolve();
    alreadyExecuted.add(code);
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.textContent = code;
        document.head.appendChild(script);
        resolve();
    });
}
